/** Generate a client id for an idempotent monitoring write. */
export function createCycleMonitoringRequestId(): string {
  const runtimeCrypto = globalThis.crypto;
  if (runtimeCrypto?.randomUUID) return runtimeCrypto.randomUUID();

  const randomHex = (length: number) =>
    Array.from({ length }, () =>
      Math.floor(Math.random() * 16).toString(16),
    ).join("");
  const variant = (8 + Math.floor(Math.random() * 4)).toString(16);
  return `${randomHex(8)}-${randomHex(4)}-4${randomHex(3)}-${variant}${randomHex(3)}-${randomHex(12)}`;
}
